module.exports = __webpack_public_path__ + "img/1 (138).801138ff.png";